import React from 'react';
import { Landmark, Briefcase, Cloud, Building2 } from 'lucide-react';

const useCases = [
  {
    icon: <Landmark />,
    title: "Banking & Financial Services",
    problem: "Stringent regulatory timelines and high-stakes system availability requirements.",
    impact: "Automated L1 triage for internal trading floor and retail banking infrastructure.",
    outcome: "45% reduction in compliance-related incident response time."
  },
  {
    icon: <Briefcase />,
    title: "IT Services Companies",
    problem: "Managing dozens of diverse client environments with limited human staff.",
    impact: "Multi-tenant AI layer that learns client-specific knowledge bases autonomously.",
    outcome: "3x increase in tickets-per-agent capacity without quality degradation."
  },
  {
    icon: <Cloud />,
    title: "SaaS Enterprises",
    problem: "Hyper-growth leading to unmanageable ticket volume and fragmented documentation.",
    impact: "AI-driven resolution engine that maintains 99.9% consistency across shifts.",
    outcome: "70% of cloud infrastructure alerts auto-resolved without human touch."
  },
  {
    icon: <Building2 />,
    title: "Large Corporations",
    problem: "Complex, siloed IT departments with high operational fragmentation.",
    impact: "Centralized AI orchestration layer that bridges legacy apps and modern cloud.",
    outcome: "Consolidated IT operations with a single autonomous diagnosis layer."
  }
];

const UseCases = () => {
  return (
    <section className="usecases-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="title">Built for Industry Scale</h2>
          <p className="subtitle">Raptic91<sup>™</sup> adapts to the unique operational logic of the world's most demanding sectors.</p>
        </div>

        <div className="usecase-grid">
          {useCases.map((useCase, index) => (
            <div key={index} className="usecase-card">
              <div className="usecase-header">
                <div className="usecase-icon">{useCase.icon}</div>
                <h3>{useCase.title}</h3>
              </div>
              <div className="usecase-body">
                <div className="case-item">
                  <span className="label">Problem:</span>
                  <p>{useCase.problem}</p>
                </div>
                <div className="case-item">
                  <span className="label">AI Impact:</span>
                  <p>{useCase.impact}</p>
                </div>
                <div className="case-item">
                  <span className="label">Business Outcome:</span>
                  <p className="outcome">{useCase.outcome}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
